import React from "react";
import { View, StyleSheet } from "react-native";
import NtText from "./NtText";
import { useTheme } from "../context/ThemeContext";

const VARIANT_ALIASES = { success: "green", warning: "yellow", danger: "red", info: "blue" };

/**
 * Status badge with a colored dot + label.
 *
 *   <NtBadge variant="green">Online</NtBadge>
 *   <NtBadge variant="red" dot={false}>Critical</NtBadge>
 */
function NtBadge({ children, variant = "gray", dot = true, style }) {
  const { theme } = useTheme();
  const key = VARIANT_ALIASES[variant] || variant;
  const color = theme[key] || theme.textDim;
  const styles = makeStyles(theme, color);

  return (
    <View style={[styles.wrap, style]}>
      {dot ? <View style={styles.dot} /> : null}
      <NtText style={styles.label}>{children}</NtText>
    </View>
  );
}

const makeStyles = (t, color) =>
  StyleSheet.create({
    wrap: {
      flexDirection: "row",
      alignItems: "center",
      gap: 5,
      paddingHorizontal: 7,
      paddingVertical: 2,
      borderRadius: 4,
      backgroundColor: color + "26", // ~15% alpha
      alignSelf: "flex-start",
    },
    dot: { width: 4, height: 4, borderRadius: 2, backgroundColor: color },
    label: {
      fontSize: 10,
      color,
      fontWeight: "600",
      letterSpacing: 0.2,
    },
  });

export default NtBadge;
